import { getPublicEnv } from "@/config/public-env";

export const brandImagePaths = {
  logo: "/brand/logo-largo-23.webp",
  mark: "/brand/isotipo.webp",
} as const;

export function resolveCatalogImageUrl(imageUrl: string | null): string {
  if (!imageUrl) {
    return brandImagePaths.mark;
  }

  if (/^https?:\/\//i.test(imageUrl)) {
    return imageUrl;
  }

  const { NEXT_PUBLIC_SUPABASE_URL } = getPublicEnv();
  const normalizedPath = imageUrl.replace(/^\/+/, "");

  if (normalizedPath.startsWith("storage/v1/")) {
    return `${NEXT_PUBLIC_SUPABASE_URL}/${normalizedPath}`;
  }

  return `${NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/${normalizedPath}`;
}
